import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProductTab from "./ProductTab";

function Products () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <AddProductForm /> */}
      <ProductTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Products;

// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TablePagination,
//   TextField,
//   Button,
//   Box,
//   Typography,
// } from "@mui/material";

// import Grid from "@mui/material/Grid";
// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// // import AddProduct from "./addproduct";

// function Products () {
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Example data, replace with API or props as needed
//   const products = [
//     {
//       image: "https://via.placeholder.com/50",
//       name: "Dog Food, Chicken & Chicken Liver Recipe",
//       id: "#7712309",
//       price: "$1,452.500",
//       quantity: 1638,
//       sale: 20,
//       stock: "Out of stock",
//       startDate: "$28,672.36",
//     },
//     // Add more product objects here
//   ];

//   // Filter products by search query
//   const filteredProducts = products.filter(product =>
//     product.name.toLowerCase().includes(search.toLowerCase())
//   );

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Handle rows per page change
//   const handleChangeRowsPerPage = event => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   return (
//     <DashboardLayout>
//       <DashboardNavbar absolute isMini />
//       {/* <MDBox mt={8}>Products</MDBox> */}
//       {/* <AddProduct /> */}
//       <Box p={2}>
//         <Typography variant='h5' gutterBottom>
//           Products list
//         </Typography>
//         <Typography variant='body2' style={{ fontSize: "12px" }} gutterBottom>
//           Tip search by Product ID: Each product is provided with a unique ID, which you can rely on
//           to find the exact product you need.
//         </Typography>

//         <Box mb={2} display='flex' justifyContent='space-between' alignItems='center'>
//           <TextField
//             label='Search here...'
//             variant='outlined'
//             size='small'
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//           />
//           <Button variant='contained' color='success'>
//             + Add new
//           </Button>
//         </Box>

//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Product</TableCell>
//                 <TableCell>Product ID</TableCell>
//                 <TableCell>Price</TableCell>
//                 <TableCell>Quantity</TableCell>
//                 <TableCell>Sale</TableCell>
//                 <TableCell>Stock</TableCell>
//                 <TableCell>Start date</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredProducts
//                 .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                 .map((product, index) => (
//                   <TableRow key={index}>
//                     <TableCell>
//                       <Box display='flex' alignItems='center'>
//                         <img
//                           src={product.image}
//                           alt={product.name}
//                           width={50}
//                           height={50}
//                           style={{ marginRight: 8 }}
//                         />
//                         {product.name}
//                       </Box>
//                     </TableCell>
//                     <TableCell>{product.id}</TableCell>
//                     <TableCell>{product.price}</TableCell>
//                     <TableCell>{product.quantity}</TableCell>
//                     <TableCell>{product.sale}</TableCell>
//                     <TableCell>
//                       <Typography color='error'>{product.stock}</Typography>
//                     </TableCell>
//                     <TableCell>{product.startDate}</TableCell>
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 15]}
//             component='div'
//             count={filteredProducts.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </TableContainer>
//       </Box>
//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default Products;
